import { EnumOption } from "./enum-option"

export const MilestoneStatus = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2,
    NotApplicable: 3,
}

export const MilestoneStatusList: EnumOption[] = [
    { value: MilestoneStatus.NotStarted, label: 'Not Started' },
    { value: MilestoneStatus.InProgress, label: 'In Progress' },
    { value: MilestoneStatus.Completed, label: 'Completed' },
    { value: MilestoneStatus.NotApplicable, label: 'Not Applicable' },
]
